import styled from 'styled-components';

const CartItemPrice = styled.p`
  padding: 0rem 0.5rem 0.5rem;
  display: flex;
  justify-content: space-between;
`;

export default CartItemPrice;
